import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tehtud valikutega pole saadaval

  <span style="color:#85c1dc;">**FI:**</span>
  Ei ole saatavilla tehdyillä vaihtoehdoilla

  <span style="color:#85c1dc;">**RU:**</span>
  Недоступно при сделанном выборе
*/
/* @__NO_SIDE_EFFECTS__ */
const m619 = msg(
  mf`Tehtud valikutega pole saadaval`,
  mf`Ei ole saatavilla tehdyillä vaihtoehdoilla`,
  mf`Недоступно при сделанном выборе`,
)

export { m619 as 'w.global.product_option.not_available_variation' }